export enum PaymentTypeEnum {
    DOWNPAYMENT = 'downpayment'
}